var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadDocAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.049,
    height: 16,
    viewBox: "0 0 17.049 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_icon",
    "data-name": "download icon",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M13.768,4.293a5.334,5.334,0,0,0-10.462,0,3.734,3.734,0,0,0,.43,7.443H6.4a.533.533,0,1,0,0-1.067H3.736a2.667,2.667,0,1,1,.031-5.334.533.533,0,0,0,.53-.475,4.267,4.267,0,0,1,8.478,0,.565.565,0,0,0,.562.475,2.667,2.667,0,1,1,0,5.334H10.67a.533.533,0,1,0,0,1.067h2.667a3.734,3.734,0,0,0,.43-7.44Zm0,0",
    transform: "translate(0.001 0)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34167",
    "data-name": "Path 34167",
    d: "M176.912,214.067l-1.352,1.353v-6.714a.533.533,0,1,0-1.067,0v6.714l-1.352-1.353a.533.533,0,1,0-.767.741l.013.013,2.262,2.263a.535.535,0,0,0,.172.115.527.527,0,0,0,.411,0,.533.533,0,0,0,.172-.115l2.262-2.263a.533.533,0,0,0-.741-.767Zm0,0",
    transform: "translate(-166.489 -201.241)",
    fill: "#727272"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDocAdmin);
export default __webpack_public_path__ + "static/media/downloadDocAdmin.91e203d968bf148e02908153804d51c2.svg";
export { ForwardRef as ReactComponent };